import { useState } from 'react'
import { checkVoidPasscode } from '../lib/passcode'
import { useApp } from '../lib/store'
import { Sheet } from './Sheet'

/**
 * Hỏi mã 6 số trước khi làm một việc không lùi lại được.
 *
 * Bàn phím vẽ sẵn ngay trong tấm trượt chứ không dùng ô nhập của trình duyệt: máy bán hàng
 * là máy bảng dựng đứng, bàn phím hệ thống bật lên là che mất nửa màn hình và che luôn mấy
 * ô chấm đang đếm. Sáu ô chấm cho biết gõ tới đâu mà không phơi con số ra cho người đứng
 * sau lưng nhìn thấy.
 *
 * Gõ đủ sáu số là tự kiểm tra luôn, không cần bấm thêm nút xác nhận — sai thì rung một cái
 * rồi xoá trắng, gõ lại.
 */

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
const LEN = 6

interface Props {
  title: string
  note?: string
  onClose: () => void
  onPass: () => void
}

export function PasscodeSheet({ title, note, onClose, onPass }: Props) {
  const shop = useApp((s) => s.shop)
  const [code, setCode] = useState('')
  const [wrong, setWrong] = useState(false)

  async function push(digit: string) {
    if (code.length >= LEN) return
    const next = code + digit
    setWrong(false)
    setCode(next)

    if (next.length < LEN) return

    if (await checkVoidPasscode(shop, next)) {
      onPass()
      return
    }
    setWrong(true)
    setCode('')
  }

  return (
    <Sheet title={title} onClose={onClose}>
      {note && <p className="sheet-note">{note}</p>}

      <div className={`pass-dots${wrong ? ' is-wrong' : ''}`} aria-label={`Đã gõ ${code.length} trên ${LEN} số`}>
        {Array.from({ length: LEN }, (_, i) => (
          <span key={i} className={i < code.length ? 'is-on' : undefined} />
        ))}
      </div>

      <p className="pass-hint" role="status">
        {wrong ? 'Mã không đúng. Gõ lại.' : 'Gõ mã 6 số của chủ quán'}
      </p>

      <div className="numpad">
        {KEYS.map((k) => (
          <button key={k} type="button" onClick={() => void push(k)}>
            {k}
          </button>
        ))}
        <button type="button" className="is-blank" disabled aria-hidden="true" />
        <button type="button" onClick={() => void push('0')}>
          0
        </button>
        <button
          type="button"
          className="numpad-del"
          onClick={() => setCode((c) => c.slice(0, -1))}
          aria-label="Xoá số vừa gõ"
        >
          ⌫
        </button>
      </div>
    </Sheet>
  )
}
